export const CREATE_RINGTONE_URL = '/ringtones';
export const GET_RINGTONES_URL = '/ringtones';
export const UPDATE_RINGTONE_URL = (id) => `/ringtones/${id}`;
export const DELETE_RINGTONE_URL = (id) => `/ringtones/${id}`;
export const INACTIVATE_RINGTONE_URL = (id) => `/ringtones/${id}/inactivate`;
export const ACTIVATE_RINGTONE_URL = (id) => `/ringtones/${id}/activate`;
export const GET_RINGTONE_SONGS_URL = (id) => `/ringtones/${id}/songs`;
